
<template>
  <MainLayout>
      <div style="padding-top:25px">
        <div class="goBack" @click='goBackPage'>
          <img src='@/assets/button/back_button.png'>
          <span class="F1-R-19 span">停留所リストに戻る</span>
        </div>
        <span class="F3-M-27">
          {{ title }}
        </span>
      </div>

      <div style="margin-top:20px;" class="body">
        <div class='row clearfix top' style="flex: 1 1 0; overflow-y: scroll;">
          <div class='col-md-6 column body-left slider'>
            <table class='table table-bordered window-table' style="margin-bottom: 10px;">
              <tbody>
                <tr>
                  <td class='td-key'>運行区分</td>
                  <td class="td-value tooLong" v-show="viewModel.transportKind==0">区域内</td>
                  <td class="td-value tooLong" v-show="viewModel.transportKind==1">区域外</td>
                </tr>
                <tr>
                  <td class='td-key'>停留所区分</td>
                  <td class="td-value tooLong" v-show="viewModel.officeFlag==0">停留所</td>
                  <td class="td-value tooLong" v-show="viewModel.officeFlag==1">事務所</td>
                </tr>
                <tr>
                  <td class='td-key'>停留所名</td>
                  <td class='td-value tooLong'>{{viewModel.stationName}}</td>
                </tr>
                <tr>
                  <td class='td-key'>停留所ID</td>
                  <td class='td-value'>{{viewModel.displayStationId}}</td>
                </tr>
                <tr>
                  <td class='td-key'>所在地</td>
                  <td class='td-value'>{{viewModel.address}}</td>
                </tr>
                <tr>
                  <td class='td-key'>緯度</td>
                  <td class='td-value'>{{viewModel.stationLat}}</td>
                </tr>
                <tr>
                  <td class='td-key'>経度</td>
                  <td class='td-value'>{{viewModel.stationLng}}</td>
                </tr>
                <tr>
                  <td style='height:250px' class='td-key'>コメント</td>
                  <td class='td-value tooLong' style="vertical-align: top">{{viewModel.note}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class='col-md-6 column body-right'>
            <div class='mapCss'>
              <GoogleMap ref='gMap' :center-point='centerPoint' :map-id='mapId'>
              </GoogleMap>
            </div>
          </div>
        </div>

        <div class='row clearfix' style="margin-bottom: 10px; height: auto;">
          <div class='col-md-6 column edit'>
            <button class='window-button buttonleft F2-M-24' @click='eiditEvent'>編集</button>
          </div>
          <div class='col-md-6 column cancel'>
            <button class='window-button buttonright F2-M-24' @click='deleteEvent()'>この停留所を削除</button>
          </div>
        </div>
      </div>

    <v-dialog v-show='showDialog' :dialog-option='dialogOption' ref='dialogWindow'></v-dialog>
  </MainLayout>
</template>

<script>
import GoogleMap from '@/components/googleMap'
import MainLayout from '../layouts/mainLayout'
import dialog from '@/components/Dialog'
import STATION_ICON from '@/assets/map_icon/map_stop_point1.png'
// import axios from 'axios'
export default {
  data () {
    return {
      title: '停留所詳細',
      viewModel: {
        stationName: '',
        stationId: '',
        addressName: '',
        address: '',
        stationLat: '',
        stationLng: '',
        note: '',
        createUser: '',
        transportKind: '',
        officeFlag: ''
      },
      mapId: 'mapStationDetail',
      centerPoint: {
        lat: 35.709,
        lng: 139.731
      },
      zoom: 12,
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      // 地图图标标记点
      pointDataList: []
    }
  },
  components: {
    MainLayout,
    GoogleMap,
    'v-dialog': dialog
  },
  mounted () {
    this.initiGoogleMap()
  },
  methods: {
    // 初始化地图和数据
    async initiGoogleMap () {
      this.viewModel = JSON.parse(sessionStorage.getItem('stationViewModel')) || {}
      let { stationId } = JSON.parse(sessionStorage.getItem('pointDataList')) || {}
      // 地图初始化
      await this.$refs.gMap.initializeGoogleMap()
      this.centerPoint = {
        lng: Number(this.viewModel.stationLng),
        lat: Number(this.viewModel.stationLat)
      }
      this.$refs.gMap.map.setCenter(this.centerPoint)
      this.$refs.gMap.map.setZoom(15)
      let markPosition03 = {
        label: stationId,
        lng: this.viewModel.stationLng,
        lat: this.viewModel.stationLat,
        icon: STATION_ICON
      }
      // 添加图标
      let imgSize03 = {width: 45, height: 60}
      let className03 = 'staion03-label-class'
      // 图标里面的字体样式
      let labelAnchor03 = {width: 23, height: 53}
      this.$refs.gMap.addSingleMaker(markPosition03, imgSize03, className03, labelAnchor03)
    },
    // 编辑
    eiditEvent () {
      sessionStorage.setItem('windowType', 2)
      this.$router.push({ name: 'StationListRegistration' })
    },
    // 删除停留所
    deleteEvent () {
      this.dialogOption.text = 'この停留所を削除してもよろしいですか?'
      this.dialogOption.showNo = true
      this.dialogOption.confirmButtonText = 'はい'
      this.dialogOption.cancelButtonText = 'いいえ'
      this.showDialog = true
      this.$refs.dialogWindow.confirm().then(() => {
        this.showDialog = false
        var param = this.$qs.stringify({stationId: this.viewModel.stationId})
        this.$axios.post('station/deletStation', param).then(response => {
          this.goBackPage()
        }).catch(error => {
          if (error.data.error === 'WBE1402') {
            console.log(error.data.error_description)
            this.showMessage(error.data.error_description)
          }
        })
      }).catch(() => {
        this.showDialog = false
      })
    },
    // message dialog
    showMessage (title, yesNoFlag, yesText, noText) {
      this.dialogOption.text = title
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialogWindow
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    },
    // 跳转页面
    goBackPage () {
      this.$router.push({ path: '/StationList' })
    }
  }

}
</script>

<style lang='scss' scoped>
.body {
  height: 100%;
  display: flex;
  flex-direction: column;
  .top {
    flex: 1;
    display: flex;
    .body-left {
      flex: 1;
      padding-left: 30px;
      overflow-y: auto;
    }
    .body-right {
      flex: 1;
    }
  }
  .bottom {
    height: 100px;
    padding-top: 10px;
    .edit {
       display: flex;
       justify-content: flex-end;
       flex: 1;
       .buttonleft {
         height: 55px;
         width: 70%;
      }
    }
    .cancel {
      display: flex;
      justify-content: flex-start;
      flex: 1;
      .buttonright {
        height: 55px;
        width: 70%;
      }
    }
  }
}

.modal-header {
    height: 100px;
    border-bottom: 0px;
    position: relative;
    .back-tittle {
      position: relative;
        text-align: left;
    }
}
.modal-title {
    font-size: 28px;
}
.modal-body {
    padding-left: 40px;
    padding-right: 40px;
}
.window-table {
    font-size: 16px;
    border: 1px solid #959595;
}
.table-bordered > tbody > tr > td {
    border: 1px solid #959595;
}
.td-title {
    background-color: #797979;
    color: #fff;
    font-size: 22px;
}
.td-key {
    width: 20%;
    min-width: 140px;
    background-color: rgb(218, 225, 230);
    font-family: 'Noto Sans CJK JP';
    color: rgb(80, 80, 80);
    font-size: 15px;
    font-weight: 400;
}
.table > tbody > tr > td {
    height: 30px;
    vertical-align: middle;
}
.table > tbody > tr > .td-value {
    padding-left: 30px;
}
.td-value {
    text-align: left;
    border: 1px solid #959595;
    font-family: 'Noto Sans CJK JP';
    color: rgb(80, 80, 80);
    font-size: 18px;
    font-weight: 500;
}
.window-button {
    width: 430px;
    height: 50px;
    background-color: rgb(110, 110, 110);
    border-radius: 10px;
    font-size: 20px;
    color: #fff;
}
.close {
    opacity: 1;
}
.mapCss {
    margin-left: -15px;
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
}
label:active {
    background-color: rgb(110, 110, 110);
}

.goBack {
  position: absolute;
  font-size: 0.7em;
  padding-left: 35px;
  cursor: pointer
}
.F1-R-19 {
    padding-left: 5px;
    // font-weight: 500 !important;
    vertical-align: middle
}
.tooLong {
    word-wrap: break-word;
    word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/router/views/StationDetail.vue